
const digest = '48bd86713767d094c2b0afc70b219879db67b3552786faee713454be50d005ee';
const classes = {"item":"_item_1sbrj_1","title":"_title_1sbrj_7","text":"_text_1sbrj_10"};
const css = `._item_1sbrj_1 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._item_1sbrj_1 ._title_1sbrj_7 {
  color: grey;
}
._item_1sbrj_1 ._text_1sbrj_10 {
  color: #000000;
  white-space: pre-line;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  